<template>
  <div>
    <Form inline class="i-form">
      <FormItem label="创建时间" :label-width="100">
        <DatePicker type="daterange" v-model="dateTime" :options="accountDateOptions" placeholder="请选择日期段、单天" class="date-time" style="width: 240px"></DatePicker>
      </FormItem>
      <FormItem label="结账月份" :label-width="100">
        <Select v-model="queryParams.settleDate" clearable style="width:150px">
          <Option v-for="(item, index) in checkoutMonth" :key="index" :value="item.settleDate">{{ item.settleDate }}</Option>
        </Select>
      </FormItem>
      <FormItem label="经营日期" :label-width="100">
        <DatePicker type="daterange" v-model="operatingDate" :options="accountDateOptions" placeholder="请选择日期段、单天" class="date-time" style="width: 240px"></DatePicker>
      </FormItem>
      <FormItem label="科目" :label-width="100">
        <Cascader :data="subjectData" change-on-select @on-change="handleSubject" style="width: 200px"></Cascader>
      </FormItem>
      <br>
      <FormItem label="入账状态" :label-width="100">
        <Select v-model="queryParams.accountStatus" clearable style="width:150px">
          <Option value="-1">全部</Option>
          <Option value="0">未入账</Option>
          <Option value="1">已入账</Option>
        </Select>
      </FormItem>
      <FormItem label="结算状态" :label-width="100">
        <Select v-model="queryParams.settlementStatus" clearable style="width:150px">
          <Option value="-1">全部</Option>
          <Option value="0">未结算</Option>
          <Option value="1">已结算</Option>
        </Select>
      </FormItem>
      <FormItem label="入账时间" :label-width="100">
        <DatePicker type="daterange" v-model="recordedTime" :options="accountDateOptions" placeholder="请选择日期段、单天" class="date-time" style="width: 220px"></DatePicker>
      </FormItem>
      <FormItem label="结算时间" :label-width="100">
        <DatePicker type="daterange" v-model="settlementTime" :options="accountDateOptions" placeholder="请选择日期段、单天" class="date-time" style="width: 220px"></DatePicker>
      </FormItem>
      <FormItem label="支付方式" :label-width="100">
        <Select v-model="selPayTypes" multiple style="width:auto; min-width: 170px">
          <Option v-for="(item, index) in payTypeData" :key="index" :value="item.dictValue">{{ item.dictDesc }}</Option>
        </Select>
      </FormItem>
      <br>
      <FormItem label="业主" :label-width="100">
        <Input type="text" v-model.trim="queryParams.owner" placeholder="姓名/手机号"></Input>
      </FormItem>
      <FormItem label="门店" :label-width="76">
        <Select v-model="queryParams.chainId" clearable filterable placeholder="id/名称 输入下拉选择" style="width:250px">
          <Option v-for="(item, index) in allHotels" :key="index" :value="item.chainId">{{ `${item.chainId}_${item.chainName}` }}</Option>
        </Select>
      </FormItem>
      <FormItem label="Xbed房间id" :label-width="120">
        <Input type="text" v-model.trim="queryParams.roomId"></Input>
      </FormItem>
      <FormItem label="预订来源" :label-width="100">
        <Select v-model="selOrderSourceIds" multiple style="width:auto; min-width: 170px">
          <Option v-for="(item, index) in sourceType" :key="index" :value="item.id">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <br>
      <FormItem label="OTA单号" :label-width="100">
        <Input type="text" v-model.trim="queryParams.otherNo"></Input>
      </FormItem>
      <FormItem label="订单号" :label-width="100">
        <Input type="text" v-model.trim="queryParams.orderNo"></Input>
      </FormItem>
      <FormItem label="工单号" :label-width="100">
        <Input type="text" v-model.trim="queryParams.cleanNo"></Input>
      </FormItem>
      <br>
      <FormItem>
        <Button type="primary" @click="handleBtn" style="margin-left: 32px; width: 100px;">查询</Button>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="exportReport" :loading="exportLoading" style="margin-left: 32px; min-width: 125px;">导出筛选结果</Button>
      </FormItem>
      <FormItem>
        <Button type="warning" style="margin-left: 32px; width: 125px;" @click="closingSettlement">关账结算</Button>
      </FormItem>
    </Form>
    <!-- Table-->
    <Content>
      <Table stripe :loading="consumloading" :columns="columns" :data="billDetailsList" style="width:1615px;"></Table>
      <div style="margin: 10px;overflow: hidden">
        <Page 
          show-sizer 
          show-total
          placement="top" 
          :total="listCount" 
          :current="queryParams.pageNum" 
          :page-size="queryParams.pageSize"
          @on-page-size-change="changePageSize" 
          @on-change="changePage"
        >
        </Page>
      </div>
    </Content>
    <!-- 关账结算弹窗 -->
    <Modal ref="sClosingModal" :loading="true" v-model="closingModal" title="关账结算" width="400" :closable="false" ok-text="确定关账" @on-cancel="cancelClosing" @on-ok="sureClosing">
      <Form ref="sClosingForm" :rules="checkValidate" :model="selCloseMonthParam" :label-width="80">
        <FormItem prop="accountMonth" label="结账月份">
          <Select v-model="selCloseMonthParam.accountMonth" class="select-style">
            <Option v-for="(item, index) in notCloseCheckoutMonth" :key="index" :value="item.settleDate">{{ item.settleDate }}</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>
    <!-- 确认关账结算弹窗 -->
    <Modal ref="sClosingModal2" :loading="true" v-model="sureClosingModal" width="400" :closable="false" ok-text="确定关账" @on-ok="customsClearance">
      <p class="close-tips">已选择关账月份 <b>{{ selCloseMonthParam.accountMonth }}</b></p>
      <p class="close-tips" v-if="unreviewedCount">存在未审核的手工入账 <b>{{ unreviewedCount }}</b> 条 <b></b></p>
      <p class="close-tips">请再次确认是否关账！</p>
    </Modal>
    <!-- 更新历史弹窗 -->
    <Modal v-model="updateModal.display" title="更新历史">
      <table class="tableData" cellspacing="0">
        <tr>
          <td>操作时间</td>
          <td>操作人</td>
          <td>更新内容</td>
        </tr>
        <tr v-if="updateModal.updateList.settlementTime">
          <td>{{updateModal.updateList.settlementTime}}</td>
          <td>-</td>
          <td>{{updateModal.updateList.settlementStatus}}</td>
        </tr>
        <tr v-if="updateModal.updateList.accountTime">
          <td>{{updateModal.updateList.accountTime}}</td>
          <td>-</td>
          <td>{{updateModal.updateList.accountStatus}}</td>
        </tr>
        <tr v-if="updateModal.updateList.ctime">
          <td>{{updateModal.updateList.ctime}}</td>
          <td>{{updateModal.updateList.creator}}</td>
          <td>创建</td>
        </tr>
      </table>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import Moment from "moment";
import Utils from "@/utils";
import API from "@/api";
import Config from "@/config";

export default {
	created() {
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.userid = Utils.findFromLocalStorage( "vue-userid" );
		this.env = Utils.findFromLocalStorage( "env", "dev" );
    this.AuthorToken = Utils.findFromLocalStorage("Author-token");
    this.headerENV = Utils.aliHeaderEnv(this.env)
	},

  data () {
    const checkSelect = {
      accountMonth: (rule, value, callback) => {
        if (!this.selCloseMonthParam.accountMonth) {
          callback(new Error('请选择结账月份'))
        } else {
          callback();
        }
      }
    }
    return {
      consumloading: false,
      exportLoading: false, // 导出按钮loading
      dateTime: [ // 创建日期
        Moment().subtract(6, 'day').format('YYYY-MM-DD'),
        Moment().format('YYYY-MM-DD')
      ],
      accountDateOptions: {
        disabledDate (current) {
          return current && current.valueOf() > Date.now()
        }
      },
      operatingDate: [], // 经营日期
      recordedTime: [], // 入账时间
      settlementTime: [], // 结算日期
      sourceType: [], // 预定来源
      selPayTypes: '', // 已选择的支付方式
      selOrderSourceIds: '', // 已选择的预定来源
      // 传给接口的查询字段
      queryParams: {
        ctimeStart: '', // 创建开始时间
        ctimeEnd: '', // 创建结束时间
        settleDate:'', // 结账月份
        accountDateStart: '', // 经营日期开始时间
        accountDateEnd: '', // 经营日期结束时间
        subjectId: 0, // 一级科目
        sonSubjectId: 0, // 二级科目
        accountStatus: -1, // 入账状态
        settlementStatus: -1, // 结算状态
        accountTimeStart: '', // 入账时间开始
        accountTimeEnd: '', // 入账时间结束
        settlementTimeStart: '', // 结束时间开始
        settlementTimeEnd: '', // 结束时间结束
        payTypes: '', // 支付方式
        owner: '', // 业主
        chainId: '', // 门店id
        roomId: '', // 房间id
        orderSourceIds: '', // 订单来源
        otherNo: '', // ota单号
        orderNo: '', // 订单号
        cleanNo: '', // 工单号
        pageNum: 1, // 当前页数
        pageSize: 10 // 每页显示的条数
      },
      billDetailsList: [], // 表格列表数据
      listCount: 0, // 分页
      closingModal: false, // 是否显示关账弹窗
      sureClosingModal: false, // 确认关账弹窗
      notCloseCheckoutMonth: [], // 未关账月份
      selCloseMonthParam: {
        accountMonth: '', // 选择要关账的月份
      },
      unreviewedCount: 0, // 未审核手工入账条数
      checkValidate: {
        accountMonth: [
          {required: true, validator: checkSelect.accountMonth, trigger: 'change' }
        ]
      },
      columns: [
        {
          title: '入账状态',
          key: 'accountStatus',
          align: "center",
          width: 130,
          render:(h,params)=>{
            return h('div',{}, params.row.accountStatus ? params.row.accountStatus : '-')
          }
        },
        {
          title: '结算状态',
          key: 'settlementStatus',
          align: "center",
          width: 130,
          render:(h,params)=>{
            return h('div',{}, params.row.settlementStatus ? params.row.settlementStatus : '-')
          }
        },
        {
          title: '结账月份',
          key: 'settleDate',
          align: "center",
          width: 130,
          render:(h,params)=>{
            let date = params.row.settleDate ? Moment(params.row.settleDate).format( 'YYYY-MM' ):'-'
            return h('div',{}, date)
          }
        },
        {
          title: '一级科目',
          key: 'subjectName',
          align: "center",
          width: 130,
          render:(h,params)=>{
            return h('div',{}, params.row.subjectName ? params.row.subjectName : '-')
          }
        },
        {
          title: '二级科目',
          key: 'sonSubjectName',
          align: "center",
          width: 140,
          render:(h,params)=>{
            return h('div',{}, params.row.sonSubjectName ? params.row.sonSubjectName : '-')
          }
        },
        {
          title: '房间',
          key: 'roomName',
          align: "center",
          width: 200,
          render:(h,params)=>{
            return h('div',{}, params.row.roomName ? params.row.roomName : '-')
          }
        },
        {
          title: '门店',
          key: 'chainName',
          align: "center",
          width: 230,
          render:(h,params)=>{
            return h('div',{}, params.row.chainName ? params.row.chainName : '-')
          }
        },
        {
          title: '业主',
          key: 'ownerName',
          align: "center",
          width: 200,
          render:(h,params)=>{
            return h('div',{}, params.row.ownerName ? params.row.ownerName : '-')
          }
        },
        {
          title: '经营日期',
          key: 'accountDate',
          align: "center",
          width: 140,
          render:(h,params)=>{
            let date = params.row.accountDate ? Moment(params.row.accountDate).format( 'YYYY-MM-DD' ):'-'
            return h('div',{},date)
          }
        },
        {
          title: '消费金额',
          key: 'realPrice',
          align: "center",
          width: 140,
          render: (h, params) => {
            let price = params.row.realPrice ? (params.row.realPrice/100).toFixed(2) : '0'
            return h('div', {}, price)
          }
        },
        {
          title: '结算金额',
          key: 'settlementPrice',
          align: "center",
          width: 140,
          render: (h, params) => {
            let price = params.row.settlementPrice ? (params.row.settlementPrice/100).toFixed(2) : '0'
            return h('div', {}, price)
          }
        },
        {
          title: '备注',
          key: 'remark',
          align: "center",
          width: 200,
          render:(h,params)=>{
            return h('p', {
              style: {
                maxHeight: '40px',
                color: '#495060',
                display: '-webkit-box',
                overflow: 'hidden',
                margin: '8px 0 7px',
                webkitLineClamp: '2',
                webkitBoxOrient: 'vertical',
                wordBreak: 'break-all'
              },
              attrs: {
                title: params.row.remark
              }
            },
            params.row.remark ? params.row.remark : '-')
          }
        },
        {
          title: '支付方式',
          key: 'payType',
          align: "center",
          width: 188,
          render:(h,params)=>{
            return h('div',{}, params.row.payType ? params.row.payType : '-')
          }
        },
        {
          title: '工单号',
          key: 'cleanNo',
          align: "center",
          width: 188,
          render:(h,params)=>{
            return h('div',{}, params.row.cleanNo ? params.row.cleanNo : '-')
          }
        },
        {
          title: '订单号',
          key: 'orderNo',
          align: "center",
          width: 230,
          render:(h,params)=>{
            return h('div',{}, params.row.orderNo ? params.row.orderNo : '-')
          }
        },
        {
          title: '入住单号',
          key: 'checkId',
          align: "center",
          width: 188,
          render:(h,params)=>{
            return h('div',{}, params.row.checkId ? params.row.checkId : '-')
          }
        },
        {
          title: '子入住单号',
          key: 'checkinInfoId',
          align: "center",
          width: 188,
          render:(h,params)=>{
            return h('div',{}, params.row.checkinInfoId ? params.row.checkinInfoId : '-')
          }
        },
        {
          title: '订单来源',
          key: 'orderSource',
          align: "center",
          width: 200,
          render:(h,params)=>{
            return h('div',{}, params.row.orderSource ? params.row.orderSource : '-')
          }
        },
        {
          title: 'OTA单号',
          key: 'otherNo',
          align: "center",
          width: 200,
          render:(h,params)=>{
            return h('div',{}, params.row.otherNo ? params.row.otherNo : '-')
          }
        },
        {
          title: '最近更新(点击查看历史)',
          key: 'operationLog',
          align: "center",
          width: 200,
          render:(h,params)=>{
            return h('a',{
              on:{
                click:()=>{
                  this.updateModal.updateList = params.row
                  this.updateModal.display = true;
                }
              }
            },params.row.operationLog ? params.row.operationLog : '-')
          }
        }
      ],
      // 更新历史弹窗
      updateModal:{
        display:false,
        updateList:{}
      },
    }
  },

  props: {
    // 科目下拉框数据
    subjectData: {
      type: Array,
      default() {
        return []
      }
    },

    // 支付方式下拉框数据
    payTypeData: {
      type: Array,
      default() {
        return []
      }
    },

    // 所有门店下拉框数据
    allHotels: {
      type: Array,
      default() {
        return []
      }
    },

    // 所有结账月份
    checkoutMonth: {
      type: Array,
      default() {
        return []
      }
    }
  },

  mounted() {
    this.$Notice.config({
			top: 150
    });
    if ( !Utils.hasPermission( 'oms_accountBill_settlementBillsReport' ) ) {
      this.$Notice.error( {
        title: "无权限操作"
      } );
      return
    }
    this.getSettlementBillsReport()
    this.getInitialData()
  },

  methods: {
    // 结算报表列表 - 账单明细
    async getSettlementBillsReport() {
      this.consumloading = true
      let _queryParams = this.queryParams
      // 创建日期
      _queryParams.ctimeStart = this.dateTime[0] ? Moment(this.dateTime[0]).format('YYYY-MM-DD') : ''
      _queryParams.ctimeEnd = this.dateTime[1] ? Moment(this.dateTime[1]).format('YYYY-MM-DD') : ''
        
      // 经营日期
      _queryParams.accountDateStart = this.operatingDate[0] ? Moment(this.operatingDate[0]).format('YYYY-MM-DD') : ''
      _queryParams.accountDateEnd = this.operatingDate[1] ? Moment(this.operatingDate[1]).format('YYYY-MM-DD') : ''

      // 入账时间 
      _queryParams.accountTimeStart = this.recordedTime[0] ? Moment(this.recordedTime[0]).format('YYYY-MM-DD') : ''
      _queryParams.accountTimeEnd = this.recordedTime[1] ? Moment(this.recordedTime[1]).format('YYYY-MM-DD') : ''

      // 结算时间 
      _queryParams.settlementTimeStart = this.settlementTime[0] ? Moment(this.settlementTime[0]).format('YYYY-MM-DD') : ''
      _queryParams.settlementTimeEnd = this.settlementTime[1] ? Moment(this.settlementTime[1]).format('YYYY-MM-DD') : ''

      // 支付方式（可多选）
      _queryParams.payTypes = this.selPayTypes && this.selPayTypes.length ? this.selPayTypes.join(',') : ''

      // 预定来源（可多选）
      _queryParams.orderSourceIds = this.selOrderSourceIds && this.selOrderSourceIds.length ? this.selOrderSourceIds.join(',') : ''

      // 过滤空字段
      _queryParams = Object.keys(_queryParams).reduce(function(c, k) {
        if (_queryParams[k] && _queryParams[k] != -1 ) {
          c[k] = _queryParams[k]
        }
        return c
      }, {})
      // console.info('_queryParams:', _queryParams)
      const resp = (await API.omsAPI[this.env].clientServer.getSettlementBillsReport(_queryParams, {'x-ca-stage':this.headerENV, 'Authorization':this.AuthorToken, 'Right': this.token})).data;
      this.consumloading = false
      if ( resp.retCode ) {
				this.$Notice.error( {
					title: resp.msg,
					desc: '获取结算账单报表数据异常'
				})
				return
			}
      this.billDetailsList = resp.list || []
      this.listCount = resp.total
    },

    // 查询按钮操作
    handleBtn() {
      this.queryParams.pageNum = 1
      this.getSettlementBillsReport()
    },

    // 获取预订来源数据
    async getInitialData () {
      // 预订来源
      let sourceTypeResp = ( await API.omsAPI[this.env].php.queryOrderSource() ).data
      if ( sourceTypeResp.retCode ) {
        this.$Notice.error( {
          title: sourceTypeResp.msg,
          desc: "获取渠道失败"
        } );
      }
      this.sourceType = sourceTypeResp.retdata;
    },

    // 选择科目
    handleSubject(value, selectedData) {
      if (selectedData.length && selectedData[0].value) {
        this.queryParams.subjectId = selectedData[0].dictValue
        this.queryParams.sonSubjectId = selectedData.length === 2 ? selectedData[1].dictValue : 0
      } else {
        this.queryParams.subjectId = this.queryParams.sonSubjectId = 0
      }
    },

    // 查询未审核的手工入账数量
		async getManualCount() {
			let params = {
        accountMonth: this.selCloseMonthParam.accountMonth
      }
      const resp = (await API.omsAPI[this.env].clientServer.getManualCount(params, {'x-ca-stage': this.headerENV, 'Authorization': this.AuthorToken})).data;
      this.unreviewedCount = resp.count
		},

    // 关账结算弹窗
    closingSettlement() {
      if ( !Utils.hasPermission( 'oms_accountBill_customsClearance' ) ) {
        this.$Notice.error( {
          title: "无权限操作"
        } );
        return
      }
      this.closingModal = true
      this.selCloseMonthParam.accountMonth = ''
      this.$emit( 'getCloseMonth', true, (MonthResp) => {
				this.notCloseCheckoutMonth = MonthResp || []
			} )
    },

    // 关账结算取消按钮
    cancelClosing() {
      this.selCloseMonthParam.accountMonth = ''
      this.$refs.sClosingForm.resetFields();
    },

    // 检查必填项是否为空
    validateResource(name) {
      let _res;
      this.$refs[name].validate((valid) => {
        _res = valid ? true : false
      })
      return _res;
    },

    // 关账结算确认弹窗
    sureClosing() {
      this.$refs.sClosingModal.buttonLoading = false;
      if(!this.validateResource('sClosingForm')) {
        return
      }
      this.$refs.sClosingModal.buttonLoading = true;
      this.sureClosingModal = true
      this.closingModal = false
      this.getManualCount()
    },

    // 确认关账结算
    async customsClearance() {
      this.$refs.sClosingModal2.buttonLoading = true;
      let param = {
        accountMonth: this.selCloseMonthParam.accountMonth,
        operatorId: this.userid,
        operatorName: this.username
      }
      const resp = (await API.omsAPI[this.env].clientServer.customsClearance(param, {'x-ca-stage':this.headerENV, 'Authorization':this.AuthorToken, 'Right': this.token})).data;
      this.$refs.sClosingModal2.buttonLoading = false;
      if ( resp.retCode ) {
				this.$Notice.error( {
					title: resp.msg,
					desc: '关账结算异常'
				})
				return
			}
      this.sureClosingModal = false
      this.$Notice.success( {
        title: '关账成功'
      })
      this.getSettlementBillsReport()
    },

    // 分页
    changePageSize(pageSize) {
      this.queryParams.pageNum = 1
      this.queryParams.pageSize = pageSize
      this.getSettlementBillsReport()
    },
    changePage(pageIndex) {
      this.queryParams.pageNum = pageIndex
      this.getSettlementBillsReport()
    },
    
    // 导出
    exportReport(){
      if ( !Utils.hasPermission( 'oms_accountBill_settlementBillsExport' ) ) {
        this.$Notice.warning( {
          title: "无权限操作"
        } );
        return
      }
      if (!this.billDetailsList.length) {
        this.$Notice.warning( {
          title: "无数据符合当前筛选条件，请调整"
        } );
        return
      }
      let _queryParams = this.queryParams
      // 创建日期
      _queryParams.ctimeStart = this.dateTime[0] ? Moment(this.dateTime[0]).format('YYYY-MM-DD') : ''
      _queryParams.ctimeEnd = this.dateTime[1] ? Moment(this.dateTime[1]).format('YYYY-MM-DD') : ''
        
      // 经营日期
      _queryParams.accountDateStart = this.operatingDate[0] ? Moment(this.operatingDate[0]).format('YYYY-MM-DD') : ''
      _queryParams.accountDateEnd = this.operatingDate[1] ? Moment(this.operatingDate[1]).format('YYYY-MM-DD') : ''

      // 入账时间 
      _queryParams.accountTimeStart = this.recordedTime[0] ? Moment(this.recordedTime[0]).format('YYYY-MM-DD') : ''
      _queryParams.accountTimeEnd = this.recordedTime[1] ? Moment(this.recordedTime[1]).format('YYYY-MM-DD') : ''

      // 结算时间 
      _queryParams.settlementTimeStart = this.settlementTime[0] ? Moment(this.settlementTime[0]).format('YYYY-MM-DD') : ''
      _queryParams.settlementTimeEnd = this.settlementTime[1] ? Moment(this.settlementTime[1]).format('YYYY-MM-DD') : ''

      // 支付方式（可多选）
      _queryParams.payTypes = this.selPayTypes && this.selPayTypes.length ? this.selPayTypes.join(',') : ''

      // 预定来源（可多选）
      _queryParams.orderSourceIds = this.selOrderSourceIds && this.selOrderSourceIds.length ? this.selOrderSourceIds.join(',') : ''

      // 过滤空字段并拼接参数
      const initParam = params => {
				let paramStr = '';
				Object.keys( params ).forEach( item => {
					if ( params[item] && params[item] != -1 ) {
						paramStr += item + '=' + params[item] + '&';

					}
				} )
				return paramStr.substring( 0, paramStr.lastIndexOf( '&' ) );
			}
      let paramsInfos = initParam( _queryParams );
			let url = `${ Config[this.env].accountUrl }outConsumptions/settlementBillsExport?${ paramsInfos }`;
      Utils.exportExcelWeighting( url, this.token, this.$Notice.error, this, 'exportLoading' )
    }

  }

}
</script>

<style lang="scss" scoped>
.close-tips {
  font-size: 14px;
  line-height: 28px;
  text-align: center;
  color: #333;
  &:first-child {
    margin-top: 20px;
  }
  &:last-child {
    margin-bottom: 20px;
  }
}
.tableData{
  width: 480px;
  border: 1px solid #ddd;
  margin: 0 auto;
  text-align: center;
  tr:nth-child(2n+1){
    background: #eee;
  }
  tr{
    line-height: 44px;
  }
}
</style>





// WEBPACK FOOTER //
// src/pages/report/bill-statement/bill-details.vue